import { render, staticRenderFns } from "./BehavioralPainGrading.vue?vue&type=template&id=7c381b18&scoped=true&"
import script from "./BehavioralPainGrading.vue?vue&type=script&lang=js&"
export * from "./BehavioralPainGrading.vue?vue&type=script&lang=js&"
import style0 from "./BehavioralPainGrading.vue?vue&type=style&index=0&id=7c381b18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c381b18",
  null
  
)

export default component.exports